import HttpClient from '@naturehouse/nh-essentials/lib/requests/HttpClient';

export default class CheckUnreadChatMessagesComponent {
    private readonly context: ContextInterface;

    private readonly cssClass: string;

    constructor(context: ContextInterface) {
        this.context = context;
        this.cssClass = 'chat-unread';
    }

    public onInit(): void {
        this.checkUnread();
    }

    private checkUnread(): void {
        if (this.context.bindings.endpoint) {
            HttpClient.get(this.context.bindings.endpoint).then((response: unknown) => {
                const unreadChatMessagesResponse = response as UnreadChatMessagesResponse;
                if (unreadChatMessagesResponse && unreadChatMessagesResponse.unread > 0) {
                    this.context.element.classList.add(this.cssClass);
                } else {
                    this.context.element.classList.remove(this.cssClass);
                }
            });
        }
    }

    static getClassName(): string {
        return 'CheckUnreadChatMessagesComponent';
    }
}
